import { useEffect, useMemo, useState } from "react";
import StateFinder from "@/utils/stateFinder";

type Region = {
  state: string;
  city: string;
  country: string;
};

export const useRegion = (): Region => {
  const stateFinder = useMemo(() => new StateFinder(), []);
  const [region, setRegion] = useState<Region>({
    state: "",
    city: "",
    country: "",
  });

  useEffect(() => {
    if (!stateFinder) return;

    (async () => {
      const detectedCountry = await stateFinder.getPossibleCountry();
      const detectedState = await stateFinder.getPossibleState();
      const detectedCity = await stateFinder.getPossibleCity();

      if (detectedCity || detectedState || detectedCountry) {
        setRegion((prev) => ({
          ...prev,
          ...(detectedCity && { city: detectedCity }),
          ...(detectedState && { state: detectedState }),
          ...(detectedCountry && { country: detectedCountry }),
        }));
      }
    })();
  }, [stateFinder]);

  return region;
};
